import React from 'react';
import { Coffee } from 'lucide-react';

/**
 * 공통 라떼 아이콘 컴포넌트
 * @param {Object} props
 * @param {string} props.className - 추가 CSS 클래스
 * @param {string} props.size - 아이콘 크기 ('sm', 'md', 'lg', 'xl') 
 * @param {string} props.variant - 스타일 변형 ('outline', 'filled', 'background')
 */
const LatteIcon = ({ 
  className = '', 
  size = 'md', 
  variant = 'outline' 
}) => {
  // 크기 매핑
  const sizeMap = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6', 
    lg: 'w-8 h-8',
    xl: 'w-12 h-12'
  };

  // 변형 스타일 매핑 (직접 색상값 사용)
  const variantMap = {
    outline: 'text-[#d97706]',
    filled: 'text-white fill-[#d97706]',
    background: 'text-white'
  };

  const iconSize = sizeMap[size] || sizeMap.md;
  const iconStyle = variantMap[variant] || variantMap.outline;

  // background 변형의 경우 배경 컨테이너와 함께 렌더링
  if (variant === 'background') {
    const containerSizeMap = {
      sm: 'w-8 h-8',
      md: 'w-12 h-12',
      lg: 'w-16 h-16', 
      xl: 'w-20 h-20'
    };
    
    const containerSize = containerSizeMap[size] || containerSizeMap.md;
    
    return (
      <div className={`inline-flex items-center justify-center bg-[#d97706] rounded-2xl ${containerSize} ${className}`}>
        <Coffee className={`${iconSize} ${iconStyle}`} />
      </div>
    );
  }

  return (
    <Coffee className={`${iconSize} ${iconStyle} ${className}`} />
  );
};

export default LatteIcon;

// 편의 함수들 export
export const LatteIconSm = (props) => <LatteIcon size="sm" {...props} />;
export const LatteIconMd = (props) => <LatteIcon size="md" {...props} />;
export const LatteIconLg = (props) => <LatteIcon size="lg" {...props} />;
export const LatteIconXl = (props) => <LatteIcon size="xl" {...props} />;

export const LatteIconOutline = (props) => <LatteIcon variant="outline" {...props} />;
export const LatteIconFilled = (props) => <LatteIcon variant="filled" {...props} />;
export const LatteIconBackground = (props) => <LatteIcon variant="background" {...props} />;
